<!-- =========================================================
     HIERARCHY FILTER
     ========================================================= -->
<app-hierarchy-filter (applied)="onFiltersApplied()" (cleared)="onFiltersCleared()">
</app-hierarchy-filter>

<!-- =========================================================
     BACK HEADER
     ========================================================= -->
<div class="back-header">
  <div class="back-icon" (click)="BackToDashboard()">
    <i class="dx-icon dx-icon-chevronleft"></i>
  </div>
  <div class="back-text">
    {{ drillDownPageTitle | translate }}
  </div>
</div>


<!-- =========================================================
     FILTER TOOLBAR
     (Card pages show only Financial Year; other pages show all)
     ========================================================= -->
<div class="report-filter-wrapper">
  <div class="report-filter-row">
    <!-- Financial Year -->
    <div class="report-filter-field">
      <label class="lable" for="FinancialYearRef">
        {{ langService.currentLang === 'mr' ? 'आर्थिक वर्ष' : 'Financial Year' }}
      </label>
      <dx-select-box id="FinancialYearRef" [(ngModel)]="FinancialYearRef" [items]="YearsList" displayExpr="p.short_name"
        valueExpr="p.id" name="FinancialYearRef" [placeholder]="'REPORT_PLACEHOLDERS.Select' | translate" [inputAttr]="{
          'aria-label': 'FinancialYearRef'
        }" [searchEnabled]="true" class="inputfield" (onValueChanged)="onYearChanged($event)">
      </dx-select-box>
    </div>

    <!-- Filter Type -->
    <div class="report-filter-field" *ngIf="!isYearlyOnly">
      <label class="lable" for="FilterRef">
        {{ langService.currentLang === 'mr' ? 'फिल्टर प्रकार' : 'Filter Type' }}
      </label>
      <dx-select-box id="FilterRef" [(ngModel)]="FilterRef" [items]="FilterList" [displayExpr]="getTranslatedName"
        valueExpr="Ref" name="FilterRef" [placeholder]="'REPORT_PLACEHOLDERS.Select' | translate" [inputAttr]="{
          'aria-label': 'FilterRef'
        }" [searchEnabled]="true" class="inputfield" (onValueChanged)="OnFilterChange($event.value)">
      </dx-select-box>
    </div>


    <!-- Half Year -->
    <div class="report-filter-field" *ngIf="!isYearlyOnly && IsShowHalfYear">
      <label for="HalfYear" class="lable">
        {{ 'FILTER_LABELS.HalfYear' | translate }}
      </label>
      <dx-select-box id="HalfYear" [(ngModel)]="HalfYear" [items]="HalfYearList" [displayExpr]="getTranslatedName"
        valueExpr="Ref" name="HalfYear" [placeholder]="'REPORT_PLACEHOLDERS.SelectHalfYear' | translate" [inputAttr]="{
          'aria-label': 'HalfYear'
        }" [searchEnabled]="true" class="inputfield" (onValueChanged)="onHalfYearChanged($event)">
      </dx-select-box>
    </div>

    <!-- Quarter -->
    <div class="report-filter-field" *ngIf="!isYearlyOnly && IsShowQuarter">
      <label for="Quarter" class="lable">
        {{ 'FILTER_LABELS.Quarter' | translate }}
      </label>
      <dx-select-box id="Quarter" [(ngModel)]="Quarter" [items]="QuarterList" [displayExpr]="getTranslatedName"
        valueExpr="Ref" name="Quarter" [placeholder]="'REPORT_PLACEHOLDERS.SelectQuarter' | translate" [inputAttr]="{
          'aria-label': 'Quarter'
        }" [searchEnabled]="true" class="inputfield" (onValueChanged)="onQuarterChanged($event)">
      </dx-select-box>
    </div>


    <!-- Month -->
    <div class="report-filter-field" *ngIf="!isYearlyOnly && IsShowMonth">
      <label for="Month" class="lable">
        {{ 'FILTER_LABELS.Month' | translate }}
      </label>
      <dx-select-box id="Month" [(ngModel)]="Month" [items]="MonthList" [displayExpr]="getTranslatedName"
        valueExpr="Ref" name="Month" [placeholder]="'REPORT_PLACEHOLDERS.SelectMonth' | translate" [inputAttr]="{
          'aria-label': 'Month'
        }" [searchEnabled]="true" class="inputfield" (onValueChanged)="onMonthChanged($event)">
      </dx-select-box>
    </div>


    <!-- Flexible Space -->
    <div class="filter-spacer"></div>
    <!-- =====================================================
         ACTION ICONS
         ===================================================== -->
    <div class="filter-actions">
      <!-- Refresh Button -->
      <button type="button" class="dashboard-refresh-btn" [class.highlight-pulse]="isNewRecordAvailable"
        [class.refreshing]="isRefreshing" [disabled]="isRefreshing" (click)="refreshReport()" [title]="isNewRecordAvailable
          ? (langService.currentLang === 'mr' ? 'नवीन माहिती उपलब्ध आहे - रिफ्रेश करा' : 'New records available - Click to refresh')
          : (langService.currentLang === 'mr' ? 'माहिती अद्यतनित करा' : 'Refresh')">
        <span class="refresh-icon-wrap" [class.spinning]="isRefreshing">
          <svg class="refresh-svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
            stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.19" />
          </svg>
        </span>
        <span class="refresh-label">
          {{ isRefreshing
          ? (langService.currentLang === 'mr' ? 'अद्यतनित...' : 'Refreshing...')
          : (langService.currentLang === 'mr' ? 'रिफ्रेश' : 'Refresh') }}
        </span>
        <!-- Attention Pulse Badge Dot when new data is available -->
        <span *ngIf="isNewRecordAvailable" class="refresh-badge-dot">
          <span class="badge-ping"></span>
          <span class="badge-core"></span>
        </span>
      </button>

      <!-- Export -->
      <!-- <button *ngIf="hasData || (data && data.length > 0)" type="button" class="toolbar-export-button"
        (click)="exportToExcel()" [attr.aria-label]="langService.currentLang === 'mr' ? 'एक्सपोर्ट' : 'Export'"
        [title]="langService.currentLang === 'mr' ? 'एक्सपोर्ट' : 'Export'">
        <i class="dx-icon dx-icon-download"></i>
        <span>{{ langService.currentLang === 'mr' ? 'एक्सपोर्ट' : 'Export' }}</span>
      </button> -->

      <!-- Filter -->
      <button *ngIf="DashboardFilterService.HasAnyVisibleFilter" type="button"
        class="toolbar-icon-button filter-icon-button" (click)="openFilterPanel()" aria-label="Open filters"
        title="Filter">
        <img src="assets/icons/filter_pink.png" alt="Filter" class="filter-icon">
      </button>
    </div>
  </div>
</div>


<!-- =========================================================
     RURAL / URBAN TOGGLE  (card pages only)
     ========================================================= -->
<div class="area-toggle-wrap" *ngIf="showAreaToggle">
  <div class="area-toggle" role="tablist">
    <button type="button" role="tab" [class.active]="areaType === 'rural'" [attr.aria-selected]="areaType === 'rural'"
      (click)="onAreaChanged('rural')">
      {{ getText('Rural', 'ग्रामीण') }}
    </button>
    <button type="button" role="tab" [class.active]="areaType === 'urban'" [attr.aria-selected]="areaType === 'urban'"
      (click)="onAreaChanged('urban')">
      {{ getText('Urban', 'शहरी') }}
    </button>
  </div>
</div>


<!-- =========================================================
     PARENT TITLE + SUMMARY CARDS  (card pages only)
     ========================================================= -->
<ng-container *ngIf="showSummaryCards">
  <h2 class="parent-title">{{ cardsTitle }}</h2>

  <!-- Level 1 -->
  <div class="summary-cards">
    <div class="summary-card" *ngFor="let c of cards" [class.active]="c.filterBy === selectedCardValue"
      [class.zero]="!c.count" (click)="onCardClick(c)" tabindex="0" role="button"
      [attr.aria-pressed]="c.filterBy === selectedCardValue" (keydown.enter)="onCardClick(c)">
      <div class="card-value">{{ c.count | number:'2.0-0' }}</div>
      <div class="card-label">{{ c.label | translate }}</div>
    </div>
  </div>

  <!-- Level 2: shown under the selected level-1 card -->
  <div class="summary-cards summary-cards--child" *ngIf="childCards.length">
    <div class="summary-card" *ngFor="let c of childCards" [class.active]="c.filterBy === selectedChildCardValue"
      [class.zero]="!c.count" (click)="onChildCardClick(c)" tabindex="0" role="button"
      [attr.aria-pressed]="c.filterBy === selectedChildCardValue" (keydown.enter)="onChildCardClick(c)">
      <div class="card-value">{{ c.count | number:'2.0-0' }}</div>
      <div class="card-label">{{ c.label | translate }}</div>
    </div>
  </div>
</ng-container>

<!-- =========================================================
     LOADER
     ========================================================= -->
<div *ngIf="isLoading" class="table-loader">
  <!-- <div class="spinner"></div>
  <p>Loading data...</p> -->
</div>
<!-- =========================================================
     TABLE CARD
     ========================================================= -->
<div class="table-wrapper">
  <div class="table-card">
    <div class="table-card-header">
      <div class="table-title">
        {{ showSummaryCards ? tableTitle : (drillDownPageTitle | translate) }}
      </div>
      <div class="table-search">
        <input type="text" [placeholder]="search_text_placeholder || 'Search here......'" aria-label="Search"
          (input)="onSearchChanged($any($event.target).value)" />
        <i class="dx-icon dx-icon-search"></i>
      </div>
    </div>
    <dx-data-grid #dataGrid [dataSource]="dataSource" [columns]="columns" [wordWrapEnabled]="true" [showBorders]="false"
      [showRowLines]="true" [columnAutoWidth]="true" [columnMinWidth]="110" [rowAlternationEnabled]="true"
      [hoverStateEnabled]="true" [allowColumnResizing]="true" width="100%" class="my-grid pink-grid"
      [sorting]="{ mode: 'single' }" (onCellPrepared)="onCellPrepared($event)"
      [remoteOperations]="{ paging: true, filtering: true, sorting: true, summary: false }">

      <dxo-load-panel [enabled]="false">
      </dxo-load-panel>

      <dxo-summary *ngIf="summaryConfig && summaryConfig.length > 0" [totalItems]="summaryConfig">
      </dxo-summary>
      <dxo-scrolling mode="standard" useNative="true">
      </dxo-scrolling>
      <dxo-filter-builder [allowHierarchicalFields]="true">
      </dxo-filter-builder>
      <dxo-paging [enabled]="true" [(pageSize)]="pageSize">
      </dxo-paging>
      <dxo-pager [showInfo]="true" [showNavigationButtons]="true">
      </dxo-pager>
      <!-- Built-in search panel removed: custom search box above is used -->
    </dx-data-grid>
  </div>
</div>